import { gql } from 'graphql-tag';
import { PriceFragment } from './priceFragment';

export const AdProductFragment = gql`
  fragment AdProductParts on AdProduct {
    id
    displayMetadata {
      name
    }
    features {
      type
    }
    pricing {
      ... on CappedUnitPrice {
        cappedPrice {
          ...PriceParts
        }
      }
    }
    price {
      ... on Price {
        ...PriceParts
      }
    }
  }
  ${PriceFragment}
`;
